import _Object$assign from "babel-runtime/core-js/object/assign";
export default function addContext(Component, contextTypes) {
    Component.contextTypes = Component.contextTypes || {};
    _Object$assign(Component.contextTypes, contextTypes);

    return Component;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-app/node_modules/@dhis2/d2-ui-core/build/es/component-helpers/addContext.js
// module id = 885
// module chunks = 0